const AgroforestryInvestmentToken = {
  "_format": "hh-sol-artifact-1",
  "contractName": "AgroforestryInvestmentToken",
  "sourceName": "contracts/core/AgroforestryInvestmentToken.sol",
  "abi": [
    {
      "inputs": [],
      "name": "ALREADY_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_EXISTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_LOCKED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_VERSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CONFIG_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_AMOUNT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_EMPTY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_POINTER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_PREDICTED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_PROJECT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_STAGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_TO",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_FUNDS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_REVENUE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_SUPPLY_ERROR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_MATURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_REDEEMABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_TOKENS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SPECIES_NOT_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKENS_EXIST",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOO_EARLY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AMOUNT",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovalForAll",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "predictedRevenue",
          "type": "uint128"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "realizedRevenue",
          "type": "uint128"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        }
      ],
      "name": "ClaimFinalized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "faceValue",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "refundReserved",
          "type": "uint256"
        }
      ],
      "name": "Minted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "ProjectFailed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensRedeemed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "name": "RedeemedRefund",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensRedeemed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        }
      ],
      "name": "RedeemedRevenue",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalRealized",
          "type": "uint256"
        }
      ],
      "name": "RevenueDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "RevenueDustSwept",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "predictedRevenue",
          "type": "uint128"
        }
      ],
      "name": "SpeciesConfigured",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "StageAudited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "maxStageCount",
          "type": "uint8"
        }
      ],
      "name": "StageCountsConfigured",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "values",
          "type": "uint256[]"
        }
      ],
      "name": "TransferBatch",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "TransferSingle",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "value",
          "type": "string"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "URI",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "DECIMALS",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DUST_SWEEP_DELAY",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TOKEN_FACE_VALUE",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "WAD",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "accounts",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        }
      ],
      "name": "balanceOfBatch",
      "outputs": [
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "name": "calculatePayout",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint128",
          "name": "predictedRevenue",
          "type": "uint128"
        }
      ],
      "name": "configureSpecies",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint8[]",
          "name": "_years",
          "type": "uint8[]"
        },
        {
          "internalType": "uint128[]",
          "name": "predictedRevenues",
          "type": "uint128[]"
        }
      ],
      "name": "configureSpeciesBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8[]",
          "name": "yearStageCounts",
          "type": "uint8[]"
        }
      ],
      "name": "configureStageCounts",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "decodeTokenId",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositRevenue",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "encodeTokenId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "name": "estimatePayoutAtPar",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "exists",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "finalizeClaim",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "getClaimState",
      "outputs": [
        {
          "internalType": "uint128",
          "name": "predictedRevenue",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "realizedRevenue",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "circulatingSupply",
          "type": "uint128"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "configured",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "finalized",
          "type": "bool"
        },
        {
          "internalType": "uint128",
          "name": "totalClaimed",
          "type": "uint128"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        }
      ],
      "name": "getExchangeRatePercent",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "percentage",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getTokenIdentity",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_project",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_stableCoin",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "_maxProjectYear",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "_speciesCount",
          "type": "uint8"
        },
        {
          "internalType": "string",
          "name": "_uri",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "isApprovedForAll",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "isStageAudited",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "markProjectFailed",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "markStageAudited",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "maxProjectYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "faceValue",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "refundAmount",
          "type": "uint256"
        }
      ],
      "name": "mint",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "faceValues",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "refundAmounts",
          "type": "uint256[]"
        }
      ],
      "name": "mintBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "project",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectFailed",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectStartTimestamp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "redeem",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "wasRefund",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "name": "redeemBatch",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "totalPaid",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalRefunds",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "name": "redeemBatchTo",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "totalPaid",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalRefunds",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "redeemTo",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "wasRefund",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "redemptionStatus",
      "outputs": [
        {
          "internalType": "bool",
          "name": "canRedeemRevenue",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "canRedeemRefund",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        },
        {
          "internalType": "string",
          "name": "status",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeBatchTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "_enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_startTimestamp",
          "type": "uint256"
        }
      ],
      "name": "setProjectStartTimestamp",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "pointer",
          "type": "address"
        }
      ],
      "name": "setSpeciesConfigPointer",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "speciesConfigPointer",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "speciesCount",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "stageCountForYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stageCountsConfigured",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        }
      ],
      "name": "sweepUnclaimedRevenue",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "swept",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "name": "totalPredictedForSpecies",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "speciesId",
          "type": "uint8"
        },
        {
          "internalType": "uint128",
          "name": "newPredictedRevenue",
          "type": "uint128"
        }
      ],
      "name": "updatePredictedRevenue",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "uri",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default AgroforestryInvestmentToken;
